import { themeIdForOverride, type PublicThemeOverrideMode } from './publicThemeOverride'

/**
 * Resolves which theme id should be applied given the viewer's auth state.
 *
 * An explicit light/dark choice made via the Navbar toggle
 * (`publicThemeOverride`) wins for everyone, authenticated or not — a pure
 * client-side, per-device override that never touches the backend-configured
 * defaults. Without an override, authenticated users see `activeTheme` and
 * anonymous visitors see `publicTheme`.
 *
 * `publicThemeOverride` is an explicit parameter (rather than read
 * internally via `getPublicThemeOverride()`) so this function stays pure
 * and trivially testable; callers needing the live browser value pass
 * `getPublicThemeOverride()` themselves.
 */
export function resolveThemeId(
  isAuthenticated: boolean,
  settings: { activeTheme?: string; publicTheme?: string } | undefined,
  envDefault: string,
  publicThemeOverride?: PublicThemeOverrideMode | null,
): string {
  if (publicThemeOverride) return themeIdForOverride(publicThemeOverride)
  if (isAuthenticated) return settings?.activeTheme ?? envDefault
  return settings?.publicTheme ?? envDefault
}

export {
  getPublicThemeOverride,
  setPublicThemeOverride,
  themeIdForOverride,
} from './publicThemeOverride'
export type { PublicThemeOverrideMode } from './publicThemeOverride'
